// src/components/MemberSearch.js
import React, { useState, useEffect } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./MemberSearch.css";
import { useSearchParams } from "react-router-dom";

const MemberSearch = ({ shadow = true }) => {
  const navigate = useNavigate();
  const [regId, setRegId] = useState("");
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const idFromUrl = searchParams.get("id");
    if (idFromUrl) {
      setRegId(idFromUrl);
    }
  }, [searchParams]);

  const handleSearch = (e) => {
    e.preventDefault();
    // Backend expects `_` instead of `/` in the `by-reg/:regId` URL path segment.
    // Normalize here so the query param is also URL-safe.
    const trimmedRegId = regId
      .toUpperCase()
      .replace(/\s/g, "")
      .replace(/\//g, "_");
    if (trimmedRegId) {
      navigate(`/search-member?id=${encodeURIComponent(trimmedRegId)}`);
    }
  };

  return (
    <Card
      className={`${shadow ? "shadow-lg" : ""} border-0 rounded-3`}
      style={{ backgroundColor: "#f9fbff" }}
    >
      <Card.Body className="p-5">
        <h4 className="fw-bold mb-3 text-center text-primary">
          🔎 Search Membership
        </h4>
        <p className="text-secondary text-center mb-4">
          Enter your <span className="fw-semibold">Registration ID</span> below
          to view your membership details.
        </p>

        <Form
          onSubmit={handleSearch}
          className="d-flex flex-column flex-md-row gap-3"
        >
          <Form.Control
            type="text"
            placeholder="e.g., MAF-WB-101/25 or 101"
            value={regId}
            onChange={(e) => setRegId(e.target.value)}
            required
            className="rounded-pill shadow-sm"
          />
          <Button
            variant="primary"
            size="sm"
            type="submit"
            className="d-flex align-items-center justify-content-center rounded-pill px-4 shadow-sm"
          >
            <FaSearch className="me-2" /> Search
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default MemberSearch;
